import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AccountManager, ApiManager, Bus, getActiveForms, NotificationManager } from '@atlas/core';
import { onPasswordResetSubmit, useActiveForm } from '@atlas/react-forms';
import { DefaultPopup } from '@atlas/ui';

import FormCom from 'common/Form/FormCom';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';

const RESET_PASSWORD_TOKEN_NAME = 'rptk';

const ResetPassword = ({ formType = 'PASSWORD_RESET' }) => {
  useEffect(() => {
    if (ApiManager.getAuthorizationToken()) {
      Bus.send({
        data: {
          withoutRedirect: true,
        },
        event: Bus.events.auth.logout,
      });
    }
  }, []);

  const { activeStep, activeType, submit } = useActiveForm(
    formType,
    onPasswordResetSubmit(AccountManager.passwordResetWithForm.bind(AccountManager)),
    getActiveForms,
  );
  const { pathname, search } = useLocation();
  const { replace: historyReplace } = useHistory();

  const searchParams = new URLSearchParams(search);
  // 'token' should be removed in future
  const resetToken = searchParams.get('token') || searchParams.get(RESET_PASSWORD_TOKEN_NAME);

  const submitHandler = useCallback(() => {
    NotificationManager.notify({
      message: 'new_password_was_changed_successfully',
      status: 'success',
      type: 'notification',
    });
    historyReplace(pathname, { search: '' });
  }, [pathname, historyReplace]);

  const onCloseHandler = useCallback(() => historyReplace(pathname), [historyReplace, pathname]);

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  if (!activeType) {
    return null;
  }

  return (
    <DefaultPopup className="popup__auth" headerTitle="new_password" onClose={onCloseHandler}>
      <div className="popup__content">
        <FormCom
          action={submit}
          additionalValues={{ resetToken }}
          buttonClassName="block"
          buttonText="accept"
          className="reset-password-form"
          form={{ fields: activeType?.steps[0]?.fields, number: activeStep }}
          onSubmit={submitHandler}
        />
      </div>
    </DefaultPopup>
  );
};

ResetPassword.propTypes = {
  formType: PropTypes.string,
};

export default ResetPassword;
